import React from 'react';
import PageHeader from 'components/PageHeader';
import { Icon, Divider, Header, Input, Button, Card } from 'semantic-ui-react';
import './AnaliseDocumentos.scss';
import LinhaDigitavel from 'components/LinhaDigitavel';

export default function AnaliseDocumentos() {
    return (
        <div className="page-content">
            <PageHeader />
            <div id="analise-documentos" className="subcontent pr-2 pl-2 pb-4">
                <Header as="h3" className="mt-4 ml-4">
                    <Icon.Group size="big">
                        <Icon name="tasks" className="primary-color" />
                    </Icon.Group>
                    <Header.Content className="primary-color">
                        Analise de Documentos
                        <Header.Subheader className="secondary-color">
                            <strong>Ajustes ValidFisco</strong>
                        </Header.Subheader>
                    </Header.Content>
                </Header>

                <Divider fitted style={{ margin: '0 12px 10px 12px', borderTopWidth: '2px' }} />

                <div id="analisar">
                    <label>ID do Processo</label>
                    <Input size="large" maxLength={9} />
                    <Button primary size="large" content="Analisar" className="d-flex">
                        Analisar
                        <Icon name="angle double right" />
                    </Button>
                </div>
                <div className="content-wrapper">
                    <Card fluid>
                        <Card.Content
                            className="header"
                            header={
                                <>
                                    <Icon name="file alternate outline" /> Boleto
                                </>
                            }
                        />
                        <Card.Content>
                            <p style={{ color: 'red' }}>
                                <Icon name="remove circle" color="red" className="mr-2" />
                                Não possível fazer a leitura do código de barras do boleto.
                            </p>
                            <p>
                                Isso acontece quando o documento scaneado pelo sistema apresenta
                                baixíssima qualidade. Para que não ocorra novamente, procure sempre
                                inserir documentos com dados e código de barra legíveis. Na maioria
                                dos casos retirar o boleto pelo portal do fornecedor ou solicitar
                                por e-mail é uma solução.
                            </p>
                            <label>Informe a linha digitável do boleto</label>
                            <LinhaDigitavel />
                            <Button
                                color="green"
                                icon="edit outline"
                                content="Reparar"
                                className="mt-2"
                            />
                        </Card.Content>
                    </Card>

                    <Card fluid>
                        <Card.Content
                            className="header"
                            header={
                                <>
                                    <Icon name="file alternate outline" /> Nota Fiscal
                                </>
                            }
                        />
                        <Card.Content>
                            <p style={{ color: 'red' }}>
                                <Icon name="remove circle" color="red" className="mr-2" />
                                Não possível fazer a leitura do código de barras do boleto.
                            </p>
                            <p>
                                Isso acontece quando o documento scaneado pelo sistema apresenta
                                baixíssima qualidade. Para que não ocorra novamente, procure sempre
                                inserir documentos com dados e código de barra legíveis. Na maioria
                                dos casos retirar a nota fiscal pelo portal do fornecedor, solicitar
                                por e-mail ou retirar no sistema Análise Fiscal são uma solução.
                            </p>
                            <label>Informe a chave de acesso da nota fiscal</label>
                            <Input style={{ width: 400 }} />
                            <Button
                                color="green"
                                icon="edit outline"
                                content="Reparar"
                                className="ml-2"
                            />
                        </Card.Content>
                    </Card>
                </div>
            </div>
        </div>
    );
}
